import React, { useState,useEffect } from 'react';
import { useDispatch,useSelector } from 'react-redux';
import {
    setupdatedashboard,setupdatedashboardBokaTV,setupdatedashboardOrderTV,setupdatedashboardDialer,
    setupdatedashboardAktivitet,setupdatedashboardProspekt,setupdatedashboardOffert,
    setupdatedashboardProjekt,setupdatedashboardTidProjekt,setupdatedashboardArende,
    setupdatedashboardAvtal,setupdatedashboardLynes,setupdatedashboardDevice,
    setupdatedashboardisMessage,setupdateesignering,setupdateesignering_kundnamn,
    ongetTagsList, setupdateesigneringerror,getLoggRepportV2,getSparadRepportV2

} from 'actions'
import {isNull} from 'lodash'

function ServerLogImport(props) {
    const dispatch = useDispatch()
    const [isConnectionOpen, setConnectionOpen] = useState(0);
    const IpAdress = useSelector(state=>state.auth.IpAdress)
    const [socket, setSocket] = useState(null);
   // const startWebsocket =()=> {
     //   console.log("TESTTTTTTTTTT")
        const createWebSocket = () => {
       const newSocket = new WebSocket("wss://socket.notyfile.se/socket");
      //   const newSocket = new WebSocket("ws://localhost:5005");

        newSocket.onopen = () => {
          const parameters = { Afid: props.Afid,userid: props.userid};
          newSocket.send(JSON.stringify(parameters));
          setConnectionOpen(1);
          setInterval(() => {
            if (newSocket.readyState === WebSocket.OPEN) {
                //newSocket.send({userid:props.userid,message:'heartbeat'});
            }
          }, 11000);
        };
        newSocket.onmessage = (event) => {
						let base64Data = ""
						try {
							let arr = String(event.data).split(' ') 
							let string = String(event.data).slice(arr[0].length)
							base64Data = Buffer.from(string, 'base64')
						}
						catch(err){
                            console.log(err, 'Error in base64 conversion')
                        }
            const data = event.data;
			console.log(data, 'datattatattat', base64Data)
            //
            //
            if (data === 'heartbeat') {
                console.log('Received heartbeat');
                // Handle heartbeat, e.g., update a last received heartbeat timestamp
            }
            if(event.data.includes("Avsluta")){
                setConnectionOpen(2);
                setSocket(null)
            }
            console.log(base64Data, 'event.data')
            if(base64Data.includes('update esign_complete')){
                dispatch(setupdateesignering(base64Data))
            }
            if(base64Data.includes('update esign_error')){
                dispatch(setupdateesigneringerror(base64Data))
            }
            if(base64Data.includes('update esign_customer_name')){
                dispatch(setupdateesignering_kundnamn(base64Data))
            }
            if(event.data.includes('update dashboard Vunnen')){
                dispatch(setupdatedashboard())
            }
            if(event.data.includes('update dashboard BokaTV')){
                dispatch(setupdatedashboardBokaTV())
            }
            if(event.data.includes('update dashboard Order')){
                dispatch(setupdatedashboardOrderTV())
            }
            if(event.data.includes('update dashboard dialer')){
                dispatch(setupdatedashboardDialer())
            }
            if(event.data.includes('update dashboard Aktivitet')){
                dispatch(setupdatedashboardAktivitet())
            }
            if(event.data.includes('update dashboard Prospekt')){
                dispatch(setupdatedashboardProspekt())
            }
            if(event.data.includes('update dashboard Offert')){
                dispatch(setupdatedashboardOffert())
            }
            if(event.data.includes('update dashboard Projekt')){
                dispatch(setupdatedashboardProjekt())
            }
            if(event.data.includes('update dashboard TidProjekt')){
                dispatch(setupdatedashboardTidProjekt())
            }
            if(event.data.includes('update dashboard Ärende')){
                dispatch(setupdatedashboardArende())
            }
            if(event.data.includes('update dashboard Avtal')){
                dispatch(setupdatedashboardAvtal())
            }
            if(event.data.includes('update dashboard Lynes')){
                dispatch(setupdatedashboardLynes())
            }
            if(event.data.includes('update dashboard device')){
                dispatch(setupdatedashboardDevice())
            }
            if(event.data.includes('update dashboard isMessage')){
                dispatch(setupdatedashboardisMessage())
            }
            if(event.data.includes('new Tagg')){
                dispatch(ongetTagsList(props.Afid))
            }
            if(event.data.includes('Rapportv2 newList')){
                dispatch(getSparadRepportV2(props.userid,props.Afid))
            }
            if(event.data.includes('Rapportv2 newLogg')){
                dispatch(getLoggRepportV2(props.userid,props.Afid))
            }
            if(event.data.includes('what IP')){
                const parameters = { userid: props.userid,message:`MyIP is ${IpAdress}`};
                newSocket.send(JSON.stringify(parameters));
            }
            if(event.data.includes('what Page')){
                const pathname = window.location.pathname
                const parameters = { userid: props.userid,message:`Page is ${pathname}`};
                newSocket.send(JSON.stringify(parameters));
            }
         };
         newSocket.onclose = () => {
            console.log('WebSocket connection closed');
            setConnectionOpen(2);
            setSocket(null); // Reset the socket state to trigger reconnect
           // setTimeout(createWebSocket, 5000)
          };
          setSocket(newSocket);
        };
    
       /* if (!socket) {
          createWebSocket();
        }
    
        return () => {
          if (isConnectionOpen === 2 ) {
            socket.close();
          }
        };*/
   // }
    React.useEffect(()=>{
        if(isNull(socket) && parseInt(isConnectionOpen) === 2 ){
            console.log("!!!!#2")
            
            createWebSocket()
            setConnectionOpen(0);
        }
    },[socket])
    React.useEffect(()=>{
        createWebSocket()
    },[])
    
    return (
        <div></div>
    );
}

export default ServerLogImport;